// src/components/LoginScreen.tsx
import React from 'react';
import { Scissors, AlertTriangle } from 'lucide-react';
import { firebaseInitialized } from '../constants/firebase';

// Hier vertellen we TypeScript wat het component verwacht te ontvangen (Props)
interface LoginScreenProps {
  onLogin: () => void;
  error: string | null;
}

const LoginScreen = ({ onLogin, error }: LoginScreenProps) => (
  <div className="min-h-screen bg-slate-50 dark:bg-slate-950 flex flex-col items-center justify-center p-4 font-sans transition-colors duration-300">
    <div className="bg-white dark:bg-slate-800 p-8 rounded-3xl shadow-xl w-full max-w-md text-center border border-slate-100 dark:border-slate-700">
      <div className="w-40 h-40 mx-auto mb-6 flex items-center justify-center">
        <img 
            src="/logo.png" 
            alt="bespanapp.nl" 
            className="w-full h-full object-contain"
            onError={(e: any) => {
                e.target.style.display = 'none';
                if (e.target.nextSibling) {
                    e.target.nextSibling.style.display = 'flex';
                }
            }}
        />
        <div className="hidden bg-yellow-300 w-24 h-24 rounded-full flex items-center justify-center shadow-lg border-4 border-white">
            <Scissors className="w-10 h-10 text-slate-800" />
        </div>
      </div>
      <h1 className="text-2xl font-bold text-slate-900 dark:text-white mb-2">Bespanapp.nl</h1>
      <p className="text-slate-500 dark:text-slate-400 mb-8">Log in om het bespan dashboard te openen.</p>
      
      {error || !firebaseInitialized ? (
          <div className="mb-6 p-4 bg-orange-50 dark:bg-orange-900/20 text-orange-800 dark:text-orange-200 text-sm rounded-xl border border-orange-100 dark:border-orange-800 text-left">
              <p className="font-bold mb-1 flex items-center"><AlertTriangle className="w-4 h-4 mr-2"/> Setup Vereist</p>
              <p>Er is een probleem met de Firebase configuratie.</p>
              {error && <p className="mt-2 text-xs font-mono text-red-500">{error}</p>}
          </div>
      ) : (
          <button onClick={onLogin} className="w-full flex items-center justify-center gap-3 bg-white dark:bg-slate-700 border border-slate-200 dark:border-slate-600 hover:bg-slate-50 dark:hover:bg-slate-600 text-slate-700 dark:text-white font-medium py-3 px-4 rounded-xl transition-all duration-200 group shadow-sm">
            <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="Google" className="w-5 h-5" />
            <span>Inloggen met Google</span>
          </button>
      )}
    </div>
  </div>
);

export default LoginScreen;